<template>
  <div class="dashboard">
    <div class="dashboard__top">
      <div
        class="dashboard__left"
        :class="{ 'dashboard__left--collapsed': collapsed }"
      >
        <left-sidebar @menuClick="collapsed = !collapsed"></left-sidebar>
      </div>
      <div class="dashboard__right">
        <div class="dashboard__right-top">
          <my-navbar
            @menuClick="collapsed = !collapsed"
            :collapsed="collapsed"
          ></my-navbar>
        </div>

        <div class="dashboard__right-bottom">
          <router-view></router-view>
        </div>
      </div>
    </div>
    <div class="dashboard__bottom">
      <my-footer></my-footer>
    </div>

    <!--     
    <my-header></my-header>
    <router-view></router-view>
    <my-footer></my-footer> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import * as types from "../store/types";

export default {
  data() {
    return {
      collapsed: false
    };
  }
};
</script>

<style>
.dashboard {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
}

.dashboard__top {
  flex: 1;
  display: flex;
}

.dashboard__bottom {
  height: 68px;
  background-color: #009feb;
}

.dashboard__left {
  width: 292px;
  box-shadow: -3px 0 10px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  z-index: 99;
  transition: all 0.25s;
  /* height: calc(100vh - 68px); */
  flex-shrink: 0;
}

.dashboard__left--collapsed {
  margin-left: -292px;
}

.dashboard__right {
  flex: 1;
  background-color: #f7f8fa;
}

.dashboard__right-top {
  min-height: 72px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
}

.dashboard__right-bottom {
  overflow-y: auto;
  height: calc(100vh - 140px);
}

@media only screen and (max-width: 768px) {
  .dashboard__left {
    position: absolute;
  }
}
</style>
